import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { Strategy, StrategyUpdate, StrategyUpdateRequest } from './types'
import { $params } from '../../../../features/router'

export const strategyEditMounted = createEvent()
export const setStrategyEdit = createEvent<StrategyUpdate>()
export const submitEditStrategy = createEvent<StrategyUpdateRequest>()

// Store
export const $strategyEdit = restore(setStrategyEdit, {
  id: '',
  clientId: '',
  accountId: '',
  title: '',
  description: '',
  commission: '',
  imageName: '',
  percentCommission: '',
  numAdditionalInvestors: '',
})

// Effects
export const getStrategy = fx<void, Strategy>({
  method: 'GET',
  url: '/strategy/',
})

export const updateStrategy = fx<StrategyUpdateRequest, Strategy>({
  method: 'POST',
  url: '/strategy/',
})

// Samples for strategy
sample({
  clock: strategyEditMounted,
  source: $params,
  fn: (params) => {
    let id = params ? params.strategyID : ''
    return {
      url: `/strategy/${id}`,
    }
  },
  target: getStrategy,
})

sample({
  clock: submitEditStrategy,
  source: $params,
  fn: (params, strategy) => {
    let id = params ? params.strategyID : ''
    return {
      url: `/strategy/${id}`,
      body: {
        ...strategy,
      },
    }
  },
  target: updateStrategy,
})

sample({
  clock: getStrategy.doneData,
  fn: (doneData) => doneData.body,
  target: setStrategyEdit,
})
